var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialCircumplexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 54.828 54.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M18.274,36.554a12.925,12.925,0,1,1,9.14,3.786,12.926,12.926,0,0,1-9.14-3.786M27.414,0A27.414,27.414,0,1,0,46.8,8.029,27.329,27.329,0,0,0,27.414,0Z",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.098,
    y1: 0.902,
    x2: 0.102,
    y2: 0.902,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d86e0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M18.267,73.992,9.635,91.09A27.418,27.418,0,0,0,62.13,78.29C55.524,90.729,41.2,98.11,29.105,91.766a12.851,12.851,0,0,1-1.552-.9c-2.363-1.5-3.5-2.8-3.765-3.911A12.94,12.94,0,0,1,28.17,69.038a4.789,4.789,0,0,0-.7-.05c-4.17,0-9.2,5-9.2,5",
    transform: "translate(-9.635 -68.988)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.043,
    y1: 0.935,
    x2: -0.038,
    y2: 0.935,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#ed0c75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#921fde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#3ecf81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39d625"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8.029,24.339A27.417,27.417,0,0,0,35.372,69.962C13.523,69.8,5.232,47.626,18.274,34.584a12.927,12.927,0,0,1,13.851-2.9l1.445-2.292-4.549-3.47L11.588,21.336a27.615,27.615,0,0,0-3.559,3",
    transform: "translate(0 -21.336)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.21,
    y1: 1.034,
    x2: 0.215,
    y2: 1.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9000ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#ff057e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M8.033,8.029a27.414,27.414,0,0,0-6.65,27.986c-3-12.087,11.584-24.879,28.408-21.307a14.438,14.438,0,0,1,2.85.88,7.245,7.245,0,0,0,8.067-1.464l.072-.072A7.2,7.2,0,0,0,38.628,2.388,27.444,27.444,0,0,0,8.033,8.029",
    transform: "translate(-0.005)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.131,
    y1: 1.132,
    x2: 0.135,
    y2: 1.132,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#ff7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a00ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 64.863,
    height: 64.863,
    transform: "translate(-10.505 56.419) rotate(-82.1)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(2.27 16.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 53.01,
    height: 41.253,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 5.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 81.133,
    height: 64.334,
    transform: "translate(-21.382 61.18) rotate(-81.63)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 79.638,
    height: 80.265,
    transform: "matrix(0.675, -0.737, 0.737, 0.675, -35.197, 20.27)",
    fill: "url(#linear-gradient-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialCircumplexLogo);
export default __webpack_public_path__ + "static/media/social_circumplex_logo.ab2957c307e0ef38e9714fce7eb50e07.svg";
export { ForwardRef as ReactComponent };